/**
 * @file index.tsx
 *
 * @fileoverview This is the job wizard page for choosing the job type.
 */
import JobiqoJobWizardJobTypePage, {
  getServerSideProps,
} from '~/jobiqo/pages/job/wizard/type';
export default JobiqoJobWizardJobTypePage;
export { getServerSideProps };
